import { FC, useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../store'
import reportsSelectors from '../../store/reports/reportsSelectors'
import { getReportAnswers } from '../../store/reports/reportsSlice'
import answersParser from '../../utils/AnswersParser'
import DividerTAG from '../DividerTAG'

const ReportSummary: FC = () => {
  const selectedReport = useSelector(reportsSelectors.selectedReport)
  const reportAnswers = useSelector(reportsSelectors.reportAnswers)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    if (selectedReport) {
      dispatch(getReportAnswers({ reportId: selectedReport?.id }))
    }
  }, [selectedReport])

  const renderAnswers = () => {
    if (!reportAnswers?.length) {
      return <Typography variant='boldTextXlarge'>No Data</Typography>
    }
    if (reportAnswers) {
      return reportAnswers.map((item, index) => {
        return (
          <Box key={`${index + item.text}`} className={'t-report-question'}>
            <Box className={'t-report-question-title'}>{item.question.text}</Box>
            <Box className='t-report-question-data'>{answersParser(item)}</Box>
            <DividerTAG className='t-report-question-separator' />
          </Box>
        )
      })
    }
  }

  return <>{renderAnswers()}</>
}

export default ReportSummary
